export default "<p>\n  fraction-rectangle-triangulated works!\n</p>\n"